import type { ComponentType } from 'react'

import type { BlueprintComponent } from '@/grove-blueprints/generated-types'

import { GroveBlueprintBox } from '../components/grove-blueprint-box'
import { GroveBlueprintButton } from '../components/grove-blueprint-button'
import { GroveBlueprintColumn } from '../components/grove-blueprint-column'
import { GroveBlueprintDivider } from '../components/grove-blueprint-divider'
import { GroveBlueprintImage } from '../components/grove-blueprint-image'
import { GroveBlueprintPicker } from '../components/grove-blueprint-picker'
import { GroveBlueprintRow } from '../components/grove-blueprint-row'
import { GroveBlueprintScrollView } from '../components/grove-blueprint-scroll-view'
import { GroveBlueprintSpacer } from '../components/grove-blueprint-spacer'
import { GroveBlueprintText } from '../components/grove-blueprint-text'
import { GroveBlueprintTextField } from '../components/grove-blueprint-text-field'
import type { GroveBlueprintComponentProps } from './grove-blueprint-component-props'

export const GROVE_BLUEPRINT_COMPONENT_MAP: Record<
  BlueprintComponent['type'],
  ComponentType<GroveBlueprintComponentProps>
> = {
  Text: GroveBlueprintText,
  Button: GroveBlueprintButton,
  TextField: GroveBlueprintTextField,
  Image: GroveBlueprintImage,
  Divider: GroveBlueprintDivider,
  Spacer: GroveBlueprintSpacer,
  Column: GroveBlueprintColumn,
  Row: GroveBlueprintRow,
  Box: GroveBlueprintBox,
  Picker: GroveBlueprintPicker,
  ScrollView: GroveBlueprintScrollView,
}
